import Switch from './SwitchView'
export default Switch
